module.exports = __webpack_public_path__ + "static/media/jaksonSolarLogo.7b1cdc1e.png";